import React from 'react';
import moment from 'moment';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import styled from 'styled-components';

import ErrorLabel from '../ErrorLabel';
import { transformLabels } from '../../../../utils/misc';
import { Colors } from '../../../../scss/common/style';

interface Props {
  id?: string;
  name?: string;
  defaultValue?: string | Date;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  cols?: number;
  label?: string;
  disabled?: boolean;
  value?: string | Date;
  height?: string | number;
  width?: string | number;
  placeholder?: string;
  min?: Date;
  max?: Date;
}

export default function DatePickerInputComponent({
  id = '',
  name = '',
  defaultValue = '',
  onBlur,
  onChange,
  cols,
  label,
  disabled = false,
  value = '',
  touched,
  errors,
  height,
  width,
  min,
  max,
  placeholder = 'd/m/y',
}: Props): JSX.Element {
  var cleanedDefaultValue =
    defaultValue === '' || defaultValue === null
      ? undefined
      : moment(defaultValue).isValid()
        ? moment(defaultValue).startOf('day').utc(true).toDate()
        : undefined;

  return (
    <div className={`form-group col-sm-${cols}`}>
      {label && (
        <LabelStyle className="ak-form-labels" {...(id ? { htmlFor: id } : {})}>
          {label || transformLabels(label)}
        </LabelStyle>
      )}
      <DatepickerWrapper>
        <DatePickerStyle
          style={{ borderRadius: '20px' }}
          id={id || undefined}
          height={height}
          left={10}
          width={width}
          name={name}
          placeholder={placeholder}
          onBlur={onBlur}
          onChange={(e) => {
            let converted = e.value instanceof Date ? e.value : moment(e.value).startOf('day').utc(true).toDate();
            e.value = converted;
            onChange(e);
          }}
          defaultValue={cleanedDefaultValue}
          disabled={disabled}
          format="dd.MM.yyyy"
          value={value instanceof Date ? value : moment(value).isValid() ? moment(value).toDate() : null}
          min={min}
          max={max}
        />
      </DatepickerWrapper>
      {touched && touched[name] && errors[name] && <ErrorLabel error={errors[name]} />}
    </div>
  );
}

const DatePickerStyle = styled(DatePicker)`
  border-radius: 20px;
  padding-bottom: 0;
  padding-left: 5px;
  height: ${(props) => (props.height ? props.height : 33)}px;
  width: ${(props) => (props.width ? props.width : '100%')};
  border: 1px solid #eeeeee !important;
  a {
    background-color: #fff !important;
    border-left: 1px solid #eeeeee !important;
    span {
      color: ${Colors.newOrage};
      background: #fff;
    }
  }
  input {
    padding-bottom: 3px;
    padding-left: 5px;
  }
`;

const DatepickerWrapper = styled.div`
  border-radius: 20px;
  position: relative;
  input {
    padding: 0 !important;
    height: 100%;
    &::placeholder {
      color: #b4b4b4 !important;
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
      padding-left: 7px;
    }
  }
`;

const LabelStyle = styled.label`
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  color: ${Colors.darkBrown};
  text-align: left;
  width: 100%;
  margin-left: 10px;
  margin-bottom: 11px;
`;